<div class="fpx-form-control">
    <fpx-label *ngIf="label" [control]="formControl" [label]="label"></fpx-label>
    <div class="fpx-field-content">
        <input [type]="hide ? 'password' : 'text'" matInput type="password" [formControl]="formControl" [ngClass]="{'input-available': formControl.value}" />
        <mat-placeholder *ngIf="placeholder" class="placeholder">{{ placeholder }}</mat-placeholder>
        <mat-icon class="eye-icon material-icons-outlined" aria-hidden="false" aria-label="visibility" (click)="hide = !hide">
            <span *ngIf="hide">visibility_off_outlined</span>
            <span *ngIf="!hide">visibility</span>
        </mat-icon>
    </div>
    <mat-error *ngIf="formControl && formControl.invalid && formControl.touched">
        {{ errorCode }}
    </mat-error>
</div>